<!--
 * @Description: 语言、地区、汇率选择面板
 * @Author: F-Stone
 * @LastEditTime: 2025-08-18 18:55:23
-->
<template>
  <div
      ref="layerDom"
      :class="$style['layer--local-switch']"
      class="flex justify-center items-center"
      @click.self="emitClose"
  >
    <div :class="$style['layer-mask']" ref="maskLayer"></div>
    <div ref="panelDom" :class="$style['panel--local-switch']" class="flex flex-col">
      <div :class="$style['panel-head']" class="flex justify-center">
        <div :class="$style['tab-bar']" class="grid grid-cols-2">
          <button
              v-for="(item, index) in tabItems"
              ref="tabItemsDom"
              :key="index"
              :data-active="item.type === activeTabType"
              :class="$style['tab-item']"
              :data-type="item.type"
              @click="activeTabType = item.type"
          >
            <span class="text">{{ item.text }}</span>
          </button>
          <div ref="selectShadow" :class="$style['select-shadow']"></div>
        </div>
        <button :class="$style['btn--close-panel']" @click="emitClose">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17 1L1 17M1 1L17 17"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
      <div :class="$style['panel-body']" class="min-h-0">
        <UtilScrollBox :class="$style['scroll-box']">
          <div :class="$style['scroll-content']">
            <div v-if="activeTabType === 'lang'" :class="$style['lang-group']" class="overflow-hidden">
              <div :class="$style['group-title']">
                <span class="text">{{ $t("400058") }}</span>
              </div>
              <div :class="$style['group-body']" class="flex">
                <button
                    v-for="(item, index) in langOptions"
                    :key="index"
                    :class="$style['option']"
                    :data-active="$i18n.locale === item.language"
                    @click="changeLang(item)"
                >
                  <span class="text">{{ item.name }}</span>
                </button>
              </div>
            </div>
            <div
                v-if="activeTabType === 'exchange'"
                :class="$style['exchange-group']"
                class="overflow-hidden"
            >
              <div :class="$style['group-title']">
                <span class="text">{{ $t("400059") }}</span>
              </div>
              <div :class="$style['group-body']" class="grid grid-cols-6">
                <button
                    v-for="(item, index) in exchangeOptions"
                    :key="index"
                    :class="$style['option']"
                    :data-active="currency === item.currency"
                    @click="changeExchange(item)"
                >
                  <span class="text uppercase">{{ item.currency }}-{{ item.symbol }}</span>
                </button>
              </div>
            </div>
          </div>
        </UtilScrollBox>
      </div>
    </div>
  </div>
</template>
<script>
import {gsap} from 'gsap'
import UtilScrollBox from '@/components/util/ScrollBox.vue'
import {mapGetters} from 'vuex'
import {setCookie, getCookie} from '@/utils/common'
import {getLanguageList, getRateList} from "@/apis/user";

export default {
  name: 'SiteLocalSwitchPanel',
  components: {UtilScrollBox},
  data() {
    return {
      activeTabType: 'lang',
      languageList: [],
      rateList: []
    }
  },
  computed: {
    ...mapGetters(['language', 'currency']),
    tabItems() {
      return [
        {text: this.$t('400056'), type: 'lang'},
        {text: this.$t('400057'), type: 'exchange'}
      ]
    },
    langOptions() {
      if (Array.isArray(this.languageList) && this.languageList.length) {
        let obj = {}
        let arr = this.languageList
        arr.forEach((v, i) => {
          if (v.language === this.language) {
            obj = v
            arr.splice(i, 1)
          }
        })
        arr.unshift(obj)
        // return arr.filter(item=>item.language !=='zh-CN')
        return arr
      }
    },
    exchangeOptions() {
      if (Array.isArray(this.rateList) && this.rateList.length) {
        let obj = {}
        let arr = this.rateList
        arr.forEach((v, i) => {
          if (v.currency === this.currency) {
            obj = v
            arr.splice(i, 1)
          }
        })
        arr.unshift(obj)
        return arr
      }
    }
  },
  watch: {
    activeTabType(val) {
      this.tabTo(val)
    }
  },
  created() {
    this.getLanguageList()
    this.getRateList()
  },
  mounted() {
    this.$nextTick(() => {
      this.tabTo(this.activeTabType, true)
    })
  },
  beforeDestroy() {
    this.emitClose()
  },
  methods: {
    getLanguageList() {
      this.languageList = []
      getLanguageList().then(res => {
        this.languageList = res.data || []
      })
    },
    getRateList() {
      getRateList().then(res => {
        this.rateList = res.data || []
      })
    },
    emitClose() {
      this.$emit('close')
    },
    tabTo(type = this.activeTabType, isInit = false) {
      const tabs = this.$refs.tabItemsDom || []
      const selectDom = Array.isArray(tabs) ? tabs.find(el => el.getAttribute('data-type') === type) : null
      gsap.to(this.$refs.selectShadow, {
        width: selectDom ? selectDom.offsetWidth : 0,
        height: selectDom ? selectDom.offsetHeight : 0,
        top: selectDom ? selectDom.offsetTop : 0,
        left: selectDom ? selectDom.offsetLeft : 0,
        duration: isInit ? 0 : 0.3
      })
    },
    changeLang(item) {
      let path = this.$route.name
      let pathArr = ['index', 'login', 'register', 'userCenter/commission', 'download', 'events']
      // 合约页面：切换语言时关闭下架弹框（但不设置"不再提示"标记）
      if (this.$route.path.startsWith('/contract/')) {
        this.$EventBus.$emit('closeContractDelistingTip');
        // 设置一个标记，表示语言切换时关闭了弹框，避免页面刷新后重新显示
        localStorage.setItem('contractDelistingTipClosedByLanguageSwitch', 'true');
      }
      setCookie('language', item.language)
      this.$store.dispatch('setLanguageName', item.name)
      document.documentElement.setAttribute('lang', item.language)
      this.$emit('closeFun')
      if (pathArr.indexOf(path) !== -1) {
        setCookie('languageType', 1)
        this.$router.replace(`/${path}/${item.language}`)
      } else {
        setCookie('languageType', 0)
        window.location.reload()
      }
      setTimeout(() => {
        this.$i18n.locale = item.language
        this.emitClose()
      }, 500)
      // const lang = item && item.value ? item.language : item
      // const name = item && item.text ? item.text : ''
      // try {
      //     setCookie('language', lang)
      //     this.$store.dispatch('setLanguageName', name)
      //     this.$store.dispatch('setLanguage', lang)
      //     document.documentElement.setAttribute('lang', lang)
      //     this.$i18n.locale = lang
      //     this.emitClose()
      // } catch (err) {
      //     console.error(err)
      // }
    },
    changeExchange(item) {
      this.emitClose()
      this.$store.dispatch('setCurrency', item.currency)
      this.$store.dispatch('setCurrencyIcon', item.symbol)
      window.location.reload()
      // try {
      //     this.$store.dispatch('setCurrency', item.name)
      //     this.$store.dispatch('setCurrencyIcon', item.sign)
      //     window.location.reload()
      // } catch (err) {
      //     console.error(err)
      // }
    },
    show() {
      return new Promise((res, rej) => {
        const mask = this.$refs.maskLayer
        const panel = this.$refs.panelDom
        if (!mask || !panel) {
          rej(new Error('maskLayer or panelDom is not found'))
          return
        }
        this.$lenis?.stop()
        gsap.timeline({defaults: {duration: 0.26}, onComplete: res})
            .from(mask, {opacity: 0})
            .from(panel, {opacity: 0, y: 20}, 0)
      })
    },
    hide() {
      return new Promise((res, rej) => {
        const mask = this.$refs.maskLayer
        const panel = this.$refs.panelDom
        if (!mask || !panel) {
          rej(new Error('maskLayer or panelDom is not found'))
          return
        }
        this.$lenis?.start()
        gsap.timeline({defaults: {duration: 0.26}, onComplete: res})
            .to(mask, {opacity: 0})
            .to(panel, {opacity: 0, y: 20}, 0)
      })
    }
  }
}
</script>

<style lang="scss" module>
@import "../../assets/css/scss-utils/scss/abstracts/mixins";
@import "../../assets/css/scss-utils/scss/abstracts/_breakpoint";
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
@import "../../assets/css/var";

:global(html[data-theme="sunlight"]) {
  .panel--local-switch {
    background-color: #fff;
    box-shadow: 0 12px 30px 0 rgba(0, 0, 0, 0.1);

    .group-body {
      .option {
        &:hover {
          background-color: rgba(#000, 0.05);
        }
      }
    }
  }
}

.layer--local-switch {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  // 滚动条
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;

    border-radius: 6px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: color(var(--font-color), 0.2);
  }

  .tab-bar {
    border-color: color(var(--site-background-color--inverted), 0.1);
  }

  .layer-mask {
    @include ab-cover;

    background-color: color(var(--site-background-color), 0.3);
  }
}

.panel--local-switch {
  position: relative;
  z-index: 100;

  width: 800px;
  height: 540px;
  padding: 0 50px;

  transition: background var(--transition-theme-color);

  border-radius: 20px;
  background: #202020;

  .panel-body {
    padding: 40px 0;
    // 让滚动容器按剩余空间计算高度
    flex: 1;
    min-height: 0;
  }

  .panel-head {
    position: relative;

    padding: 35px 0;

    border-bottom: 1px solid color(var(--site-background-color--inverted), 0.1);
  }

  .tab-bar {
    position: relative;

    padding: 2px;

    border: 1px solid color(var(--site-background-color--inverted), 0.2);
    border-radius: 6px;

    .select-shadow {
      position: absolute;

      border-radius: 4px;
      background-color: color(var(--theme-color));
    }
  }

  .tab-item {
    font-size: 14px;
    line-height: 1;

    position: relative;
    z-index: 10;

    padding: 8px 18px;

    transition: var(--transition-theme-color);
    text-align: center;

    &[data-active="true"] {
      color: #000;
    }
  }

  .btn--close-panel {
    font-size: 14px;

    position: absolute;
    top: 50%;
    right: -10px;

    padding: 10px;

    transition: 0.26s ease;
    transform: translateY(-50%);

    color: color(var(--font-color), 0.6);

    svg {
      width: 1em;
      height: 1em;
    }

    &:hover {
      color: color(var(--font-color));
    }
  }

  .lang-group {
    .group-body {
      // 移除导致水平滚动的负边距与不换行
      margin-right: 0;
      flex-wrap: wrap;
      gap: 10px 20px;
    }

    .option {
      // 使用 gap 管理间距，无需额外外边距
      margin: 0;
    }
  }

  .exchange-group {
    .group-body {
      gap: 15px 10px;
    }

    // 货币代码与符号混排，强制 LTR 避免阿语等 RTL 字符串错乱
    .option .text {
      direction: ltr;
      unicode-bidi: isolate;
    }
  }

  .group-title {
    font-size: 14px;
    font-weight: 500;

    margin-bottom: 25px;

    color: var(--font-color);
  }

  .group-body {
    .option {
      font-size: 14px;

      padding: 6px 14px;

      transition: background 0.26s ease;

      border-radius: 6px;

      &:hover {
        background-color: #282828;
      }

      &[data-active="true"] {
        color: #000;
        background-color: color(var(--theme-color));
      }
    }
  }
}

@include media-breakpoint-down(lg) {
  .panel--local-switch {
    width: 100%;
    height: 100vh;
    padding: 6%;

    .panel-head {
      padding-top: 68px;
    }

    .panel-body {
      padding: 30px 0;
    }

    .exchange-group {
      .group-body {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }

    .btn--close-panel {
      top: 20px;
    }

    .tab-bar {
      width: 100%;
    }
  }
}
</style>
